module.exports = __webpack_public_path__ + "static/media/no_barcode.e39afed7.png";